// أدوار المستخدم في الشركة — 4 أدوار جديدة، والأسماء القديمة تُقبل كجسر توافق مع بناء الجوال ما قبل هجرة سبتمبر 2026.
export const ADMIN_ROLES = ["company_admin", "system_admin", "admin"];
export const MANAGER_ROLES = [...ADMIN_ROLES, "branch_manager", "manager", "hr"];
export const ALL_ROLES = [...MANAGER_ROLES, "employee"];

// الدور الفعلي (الجديد) موجود في hierarchy_role حين يُرسله الخادم؛ role يبقى بالاسم القديم لتوافق النسخ المثبَّتة.
const eff = (u) => u?.hierarchy_role || u?.role;

export const isAdmin = (u) => ADMIN_ROLES.includes(eff(u));
export const isCompanyAdmin = (u) => eff(u) === "company_admin";
export const isBranchManager = (u) => eff(u) === "branch_manager";

// نسمّي الوظيفة الحالية للمستخدم بشكل موحّد
export const roleLabel = (role, t) => {
  const key = ({
    company_admin: "companyAdmin", system_admin: "systemAdmin",
    branch_manager: "branchManager", employee: "employee",
    admin: "companyAdmin", manager: "branchManager", hr: "employee",
  })[role] || "employee";
  return t(`roles.${key}`);
};
